import { HttpClient } from '../../httpClient'
import { OpalApiRequestBody, OpalApiResponseDocument } from '../../schema'

interface CreateMomentScheduleParams {
  requestBody: OpalApiRequestBody<'CreateMomentScheduleV3'>
}

export async function createMomentSchedule({
  requestBody,
}: CreateMomentScheduleParams): Promise<
  OpalApiResponseDocument<'CreateMomentScheduleV3', 201>
> {
  const url = new URL('/moment_schedules/v3', window.location.origin)
  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
